var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({attrs:{"outlined":"","dense":"","label":_vm.$t('identity.mail') + _vm.$t('meta.star'),"rules":[_vm.rules.required, _vm.rules.email],"prepend-icon":"mdi-email","clearable":""}},'v-text-field',_vm.$attrs,false),_vm.$listeners),[_vm._t("append-outer",null,{"slot":"append-outer"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }